export const STORES = 'STORES'
export const STORES_STATUS = 'STORES_STATUS'
export const DELETE_STORE_STATUS = 'DELETE_STORE_STATUS'
export const DELETE_STORE = 'DELETE_STORE'
export const CREATE_STORE_STATUS = 'CREATE_STORE_STATUS'
export const CREATE_STORE = 'CREATE_STORE'
